<template>
  <div class="container">
    <div class="columns">
      <div class="column is-5 is-offset-one-quarter">
        <h1 class="title">Duda Signature Generator</h1>
        <form>
          <b-field label="Department">
            <b-select
              placeholder="Select department"
              rounded
              v-model="department"
            >
              <option
                v-for="(department, key) in departments"
                :value="department.id"
                :key="key"
              >
                {{ department.name }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Full Name">
            <b-input
              v-model="name"
              placeholder="Full Name"
              rounded
            ></b-input>
          </b-field>
          <b-field label="Title">
            <b-input
              v-model="title"
              placeholder="Title"
              rounded
            ></b-input>
          </b-field>
          <b-field label="Phone Number">
            <b-input
              v-model="phone"
              type="text"
              placeholder="+972-55-5555555"
              rounded
            ></b-input>
          </b-field>
          <b-field
            label="Address"
            v-if="departments[department].address"
          >
            <b-input
              v-model="address"
              type="text"
              placeholder="123 Anytown St, City, State, Zip code, IL/USA"
              rounded
            ></b-input>
          </b-field>
          <div
            class="version-field"
            v-if="departments[department].links.length > 1"
          >
            <b-radio
              v-model="version"
              v-for="(ver, index) in departments[department].links"
              :key="index"
              :native-value="index"
              name="version"
            >Version {{index + 1}}
            </b-radio>
          </div>
        </form>
        <div
          class="result"
          ref="result"
        >
          <div :style="generalStyle">
            <div :style="nameStyle">{{name.toUpperCase()}}</div>
            <div :style="titleStyle">{{title}}</div>
            <div
              :style="addressStyle"
              v-if="departments[department].address"
            >{{address}}</div>
            <div :style="subSectionStyle">
              <span :style="phoneStyle">{{phone}}</span> <span v-if="phone"> | </span><span><a
                  :style="linkStyle"
                  :href="departments[department].links[version].url"
                >{{departments[department].links[version].text}}</a></span>
            </div>
            <IconsSection />
          </div>
        </div>
        <CopyToClipboard selector=".result" />
         <b-button
          rounded
          @click="isHelpModalActive = true"
          type="is-secondary"
          class="is-pulled-right"
          outlined
        >Help</b-button>
        <b-button
          rounded
          @click="isHubSpotModalActive = true"
          type="is-secondary"
          class="hubspot-button is-pulled-right"
          outlined
        >Copy to HubSpot</b-button>
        <b-modal
          :active.sync="isHelpModalActive"
          :width="500"
        >
          <HelpModal />
        </b-modal>
        <b-modal
          :active.sync="isHubSpotModalActive"
          :width="500"
        >
          <HubSpotModal :htmlContent="this.$refs.result" />
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { departments } from '../departments.js'
import HelpModal from './HelpModal';
import HubSpotModal from './HubSpotModal';
import IconsSection from './IconsSection';
import CopyToClipboard from './CopyToClipboard';

export default {
  name: 'Generator',
  data () {
    return {
      departments,
      department: 0,
      version: 0,
      isHelpModalActive: false,
      isHubSpotModalActive: false,
      name: 'John Smith',
      phone: '+972-55-5555555',
      title: 'Title',
      address: '123 Anytown St, City, State, Zip code, IL/USA ',
      generalStyle: {
        color: '#222a2c',
        'font-family': 'Verdana',
        'font-size': '12px',
        'font-style': 'normal',
        'font-weight': 'normal'
      },
      nameStyle: {
        'font-weight': '700',
        'line-height': '12px',
        'margin-bottom': '2px'
      },
      phoneStyle: {
        'font-size': '11px'
      },
      subSectionStyle: {
        'line-height': '12px',
        'margin': '3px 0 5px 0'
      },
      addressStyle: {
        'line-height': '12px',
        'font-size': '11px'
      },
      linkStyle: {
        'font-size': '11px',
        color: '#f44820 !important',
        'text-decoration': 'none'
      },
      titleStyle: {
        'margin-bottom': '6px'
      }
    }
  },
  watch: {
    department: function (val) {
      if (departments[val].links.length === 1) {
        this.version = 0
      }
    }
  },
  components: {
    HelpModal,
    HubSpotModal,
    IconsSection,
    CopyToClipboard
  }
}
</script>

<style>
.result {
  margin: 15px 0 15px 0;
  box-shadow: 0 0 50px 1px rgba(0, 0, 0, 0.1);
  padding: 15px 10px 10px 15px;
  border-radius: 20px;
}

.version-field {
  margin-top: 20px;
}

.hubspot-button {
  margin-right: 10px;
}
</style>
